import { type HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { SkillsHttpClient } from './skills.http-client';
import { SkillsActions } from './skills.store';

@Injectable({ providedIn: 'root' })
export class SkillsEffects {
  private readonly actions$ = inject(Actions);
  private readonly http = inject(SkillsHttpClient);

  public fetchAvailableSkills$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SkillsActions.fetchAvailableSkills),
      switchMap(() =>
        this.http.fetchAvailableSkills().pipe(
          map(data => SkillsActions.fetchAvailableSkillsSuccess({ payload: { data } })),
          catchError((error: HttpErrorResponse) =>
            of(SkillsActions.fetchAvailableSkillsFailed({ payload: { error } })),
          ),
        ),
      ),
    ),
  );
}
